<template>
  <div class="containerTable" style="padding:20px;">
    <vxe-toolbar
      id="toolbarId_ba5"
      :custom="{ storage: true }"
      export
      :refresh="{ query: RefreshList }"
    >
      <template v-slot:buttons>
        <el-button
          v-if="getLimit('driverManage_search_button')"
          @click="funcFilter"
          >查询</el-button
        >
        <el-button
          v-if="getLimit('driverManage_add_button') && isTopBranch"
          @click="funcAdd"
          >新增</el-button
        >
        <el-button
          v-if="
            getLimit('driverManage_import_button') && ctmsShow && isTopBranch
          "
          @click="funcImport()"
          >导入</el-button
        >
        <el-button
          v-if="
            getLimit('driverManage_checkQuire_button') && isAdmin && isTopBranch
          "
          @click="funcheckQuire"
          >设置必填项</el-button
        >
        <!-- <el-button v-if="getLimit('driverManage_RealName_button')&&isTopBranch" @click="toRealName">实名认证</el-button> -->
        <el-button
          v-if="getLimit('driverManage_export_button')"
          @click="funcExport"
          >导出</el-button
        >
      </template>
    </vxe-toolbar>
    <vxe-table
      ref="xTable"
      border
      resizable
      stripe
      class="mytable-style"
      highlight-current-row
      highlight-hover-row
      :cell-class-name="cellClassName"
      row-id="id"
      height="80%"
      :data="tableData"
      :loading="loading"
      :sort-config="{ remote: true }"
      export-config
      show-overflow
      align="center"
      @sort-change="sortList"
    >
      <vxe-table-column type="checkbox" width="60" fixed="left" />
      <vxe-table-column>
        <vxe-table-column
          field="authStatusExt"
          title="审核状态"
          :formatter="
            ({ cellValue }) => formatterField({ cellValue }, 'authStatusExt')
          "
          min-width="120"
          sortable
        />
        <template v-slot:header>
          <el-select
            v-model="listQuery.authStatusExt"
            placeholder="请选择"
            clearable
          >
            <el-option
              v-for="item in authStatusExtOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="authTime"
          min-width="420"
          title="审核时间"
          sortable
        />
        <template v-slot:header>
          <el-date-picker
            v-model="listQuery.authTimeRange"
            type="datetimerange"
            value-format="yyyy-MM-dd HH:mm:ss"
            :picker-options="optionsPicker"
            :default-time="['00:00:00', '23:59:59']"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            @change="value => changeDate(value, 'authTime')"
          />
        </template>
      </vxe-table-column>
      <!-- 验签方式 -->
      <!-- <vxe-table-column>
        <vxe-table-column field="authType" title="验签方式" min-width="120">
          <template v-slot="{ row }">
            {{ row.authType === 0 ? "手机号" : "人脸" }}
          </template>
        </vxe-table-column>
        <template v-slot:header>
          <el-select
            v-model="listQuery.authStatusExt"
            placeholder="请选择"
            clearable
          >
            <el-option
              v-for="item in authStatusExtOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </template>
      </vxe-table-column> -->
      <!-- 验签时间 -->
      <!-- <vxe-table-column>
        <vxe-table-column
          field="authTime"
          min-width="420"
          title="审核时间"
          sortable
        />
        <template v-slot:header>
          <el-date-picker
            v-model="listQuery.authTimeRange"
            type="datetimerange"
            value-format="yyyy-MM-dd HH:mm:ss"
            :picker-options="optionsPicker"
            :default-time="['00:00:00', '23:59:59']"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            @change="value => changeDate(value, 'authTime')"
          />
        </template>
      </vxe-table-column> -->
      <vxe-table-column>
        <vxe-table-column
          field="name"
          title="驾驶员姓名"
          min-width="130"
          sortable
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.name"
            placeholder="请输入驾驶员姓名"
            clearable
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="phone"
          title="联系方式"
          min-width="130"
          sortable
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.phone"
            placeholder="请输入联系方式"
            clearable
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="identificationNumber"
          title="身份证号"
          min-width="180"
          sortable
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.identificationNumber"
            placeholder="请输入身份证号"
            clearable
          />
        </template>
      </vxe-table-column>

      <vxe-table-column>
        <vxe-table-column
          field="idCardDueDate"
          title="身份证到期日期"
          min-width="420"
          sortable
        />
        <template v-slot:header>
          <el-date-picker
            v-model="listQuery.driverLicenseDueDateRange4"
            type="datetimerange"
            value-format="yyyy-MM-dd HH:mm:ss"
            :picker-options="optionsPicker"
            :default-time="['00:00:00', '23:59:59']"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            @change="value => changeDate(value, 'idCardDueDate')"
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="vehicleLicenseNumber"
          title="车辆牌照号"
          min-width="200"
          sortable
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.vehicleLicenseNumber"
            placeholder="请输入车辆牌照号"
            clearable
          />
        </template>
      </vxe-table-column>

      <vxe-table-column>
        <vxe-table-column
          field="driverLicense"
          title="机动车驾驶证号"
          min-width="180"
          sortable
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.driverLicense"
            placeholder="请输入机动车驾驶证号"
            clearable
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="driverLicenseDueDate"
          title="驾驶证到期日期"
          min-width="420"
          sortable
        />
        <template v-slot:header>
          <el-date-picker
            v-model="listQuery.driverLicenseDueDateRange"
            type="daterange"
            value-format="yyyy-MM-dd"
            :picker-options="optionsPicker"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            @change="value => changeDate(value, 'driverLicenseDueDate')"
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="vehicleLicense"
          title="车辆行驶证档案编号"
          min-width="180"
          sortable
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.vehicleLicense"
            placeholder="请输入车辆行驶证档案编号"
            clearable
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="vehicleLicenseDueDate"
          title="车辆行驶证到期日期"
          min-width="420"
          sortable
        />
        <template v-slot:header>
          <el-date-picker
            v-model="listQuery.driverLicenseDueDateRange1"
            type="daterange"
            value-format="yyyy-MM-dd"
            :picker-options="optionsPicker"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            @change="value => changeDate(value, 'vehicleLicenseDueDate')"
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="roadTransportCertificateNumber"
          title="道路运输证"
          min-width="180"
          sortable
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.roadTransportCertificateNumber"
            placeholder="请输入道路运输证"
            clearable
          />
        </template>
      </vxe-table-column>

      <vxe-table-column>
        <vxe-table-column
          field="roadTransportCertificateDate"
          title="道路运输证到期日期"
          min-width="420"
          sortable
        />
        <template v-slot:header>
          <el-date-picker
            v-model="listQuery.driverLicenseDueDateRange2"
            type="daterange"
            value-format="yyyy-MM-dd"
            :picker-options="optionsPicker"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            @change="value => changeDate(value, 'roadTransportCertificateDate')"
          />
        </template>
      </vxe-table-column>

      <vxe-table-column>
        <vxe-table-column
          field="workLicense"
          title="道路运输从业资格证号"
          min-width="220"
          sortable
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.workLicense"
            placeholder="请输入道路运输从业资格证号"
            clearable
          />
        </template>
      </vxe-table-column>

      <vxe-table-column>
        <vxe-table-column
          field="workLicenseDueDate"
          title="道路运输从业资格证到期日期"
          min-width="420"
          sortable
        />
        <template v-slot:header>
          <el-date-picker
            v-model="listQuery.driverLicenseDueDateRange3"
            type="daterange"
            value-format="yyyy-MM-dd"
            :picker-options="optionsPicker"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            @change="value => changeDate(value, 'workLicenseDueDate')"
          />
        </template>
      </vxe-table-column>
      <!-- 挂车信息 -->
      <vxe-table-column>
        <vxe-table-column
          field="isHasTrailer"
          title="是否挂车"
          :formatter="
            ({ cellValue }) => formatterField({ cellValue }, 'isHasTrailer')
          "
          min-width="100"
          sortable
        />
        <template v-slot:header>
          <el-select
            v-model="listQuery.isHasTrailer"
            placeholder="请选择"
            clearable
          >
            <el-option
              v-for="item in isHasTrailerOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="trailerNum"
          title="挂车车牌照号"
          min-width="200"
          sortable
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.trailerNum"
            placeholder="请输入车辆牌照号"
            clearable
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="vehicleTotalWeight"
          title="总质量/挂车车头整备质量(Kg)"
          min-width="240"
          sortable
        />
        <template v-slot:header>
          <el-row>
            <el-col :span="11">
              <el-input
                v-model="listQuery.vehicleTotalWeightStart"
                type="number"
                placeholder="下限"
                clearable
              />
            </el-col>
            <el-col :span="11" :offset="2">
              <el-input
                v-model="listQuery.vehicleTotalWeightEnd"
                type="number"
                placeholder="上限"
                clearable
              />
            </el-col>
          </el-row>
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="vehicleLoadWeight"
          title="核定载质量/准牵引总质量(Kg)"
          min-width="240"
          sortable
        />
        <template v-slot:header>
          <el-row>
            <el-col :span="11">
              <el-input
                v-model="listQuery.vehicleLoadWeightStart"
                type="number"
                placeholder="下限"
                clearable
              />
            </el-col>
            <el-col :span="11" :offset="2">
              <el-input
                v-model="listQuery.vehicleLoadWeightEnd"
                type="number"
                placeholder="上限"
                clearable
              />
            </el-col>
          </el-row>
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="correspondenceAddress"
          title="通信地址"
          min-width="250"
          sortable
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.correspondenceAddress"
            placeholder="请输入通信地址"
            clearable
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="homeAddress"
          title="详细地址"
          min-width="250"
          sortable
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.homeAddress"
            placeholder="请输入详细地址"
            clearable
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="gmtCreated"
          title="注册时间"
          min-width="420"
          sortable
        />
        <template v-slot:header>
          <el-date-picker
            v-model="listQuery.gmtCreatedRange"
            type="daterange"
            value-format="yyyy-MM-dd"
            :picker-options="optionsPicker"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            @change="value => changeDate(value, 'gmtCreated')"
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          v-if="ctmsShow"
          field="vehicleNetStatus"
          :formatter="
            ({ cellValue }) => formatterField({ cellValue }, 'vehicleNetStatus')
          "
          title="车辆入网"
          min-width="130"
          sortable
        />
        <template v-slot:header>
          <el-select
            v-model="listQuery.vehicleNetStatus"
            placeholder="请选择"
            clearable
          >
            <el-option
              v-for="item in vehicleNetStatusOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </template>
      </vxe-table-column>
      <vxe-table-column title="操作" min-width="300" fixed="right">
        <template slot-scope="scope">
          <el-tooltip
            v-if="
              getLimit('driverManage_RealName_button') &&
                (!scope.row.verifyFlagImg || scope.row.verifyFlagImg != 1) &&
                verifyType == 2
            "
            class="item"
            effect="dark"
            content="实名认证"
            placement="top"
          >
            <vxe-button
              type="text"
              @click="toRealName(scope.row.partyCode, scope.row.peopleImg)"
            >
              <em class="el-icon-user-solid" />
            </vxe-button>
          </el-tooltip>
          <el-tooltip
            v-if="getLimit('driverManage_detail_button')"
            class="item"
            effect="dark"
            content="详情"
            placement="top"
          >
            <vxe-button
              type="text"
              @click="funcDetail(scope.row.code, scope.row.partyCode)"
            >
              <em class="el-icon-document" />
            </vxe-button>
          </el-tooltip>
          <el-tooltip
            v-if="getLimit('driverManage_edit_button') && isTopBranch"
            class="item"
            effect="dark"
            content="编辑"
            placement="top"
          >
            <vxe-button
              type="text"
              @click="funcEdit(scope.row.code, scope.row.partyCode)"
            >
              <em class="el-icon-edit" />
            </vxe-button>
          </el-tooltip>
          <el-tooltip
            v-if="getLimit('driverManage_delete_button') && isTopBranch"
            class="item"
            effect="dark"
            content="删除"
            placement="top"
          >
            <vxe-button type="text" @click="funcDelete(scope.row.partyCode)">
              <em class="el-icon-delete" />
            </vxe-button>
          </el-tooltip>
          <el-tooltip
            v-if="
              getLimit('driverManage_ApplyDis_button') &&
                showApplyDisBtn(scope.row)
            "
            class="item"
            effect="dark"
            content="申请DIS"
            placement="top"
          >
            <vxe-button type="text" @click="funcApply(scope.row.partyCode)">
              <em class="el-icon-connection" />
            </vxe-button>
          </el-tooltip>
          <el-tooltip
            v-if="scope.row.authStatusExt == 3 && !scope.row.memNum"
            class="item"
            effect="dark"
            content="申请虚拟账号"
            placement="top"
          >
            <vxe-button type="text" @click="funcDobiz(scope.row.code)">
              <i class="el-icon-connection" />
            </vxe-button>
          </el-tooltip>
          <el-tooltip
            v-if="driverManage_ApplyDis_button && showApplyDisBtn(scope.row)"
            class="item"
            effect="dark"
            content="申请DIS"
            placement="top"
          >
            <vxe-button type="text" @click="funcApply(scope.row.partyCode)">
              <i class="el-icon-connection" />
            </vxe-button>
          </el-tooltip>
          <template v-if="scope.row.gmiId">
            <!-- <el-tooltip v-if="driverManage_recoveryBackMoney_button" class="item" effect="dark" content="万金油余额回收" placement="top">
              <vxe-button type="text" @click="funcRecoveryBackMoney(scope.row)">
                <i class="el-icon-s-release" />
              </vxe-button>
            </el-tooltip>
            <el-tooltip v-if="driverManage_cancelRecharge_button" class="item" effect="dark" content="万金油待领取撤销" placement="top">
              <vxe-button type="text" @click="funcCancelRecharge(scope.row)">
                <i class="el-icon-document-delete" />
              </vxe-button>
            </el-tooltip> -->
            <el-tooltip
              v-if="driverManage_oilOrderBackMoney_button"
              class="item"
              effect="dark"
              content="万金油余额"
              placement="top"
            >
              <vxe-button type="text" @click="funOilOrderBackMoney(scope.row)">
                <i class="el-icon-s-order" />
              </vxe-button>
            </el-tooltip>
          </template>
        </template>
      </vxe-table-column>
    </vxe-table>
    <vxe-pager
      :loading="loading"
      :current-page.sync="listQuery.pageNum"
      :page-size.sync="listQuery.pageSize"
      :page-sizes="Pagingconf"
      :total="listQuery.total"
      :layouts="[
        'PrevJump',
        'PrevPage',
        'Number',
        'NextPage',
        'NextJump',
        'Sizes',
        'FullJump',
        'Total'
      ]"
      @page-change="handlePageChange"
    />
    <vxe-modal
      v-model="modelImportFlag"
      title="导入"
      width="1300"
      height="800"
      resize
    >
      <driverImport ref="driverImportRef" @hideModel="hideModel" />
    </vxe-modal>
    <downloadData ref="downloadRef" />
    <realName ref="realNameRef" @onSuccess="hideModelR" />
    <oilOrderBackMoney ref="oilOrderBackMoneyRef" />
    <oilRecoveryBackMoney ref="oilRecoveryBackMoneyRef" />
    <oilCancelRecharge ref="oilCancelRechargeRef" />
  </div>
</template>
<script>
import request from "@/utils/request";
import { getRole } from "@/utils/getRole";
import { maYiBlockChain } from "@/api/shipment";
import { verifyIdentityOnOff, syncMemName } from "@/api/driver";
import driverImport from "./components/driverImport";
import realName from "./components/realName";
import oilOrderBackMoney from "./components/oilOrderBackMoney";
import oilRecoveryBackMoney from "./components/oilRecoveryBackMoney";
import oilCancelRecharge from "./components/oilCancelRecharge";
export default {
  // name: "DriverList",
  components: {
    driverImport,
    realName,
    oilOrderBackMoney,
    oilRecoveryBackMoney,
    oilCancelRecharge
  },
  data() {
    return {
      exportObj: {
        exportUrl: "/ntocc-basic-api/driver/exportDriver", //导出接口
        name: "实际承运人管理"
      },
      isCtms: true, //默认显示 同城系统时隐藏
      exportableQuantity: localStorage.getItem("exportableQuantity"),
      exportableUrl: "ntocc-basic-api/driver/exportDriver",
      loading: false,
      tableData: [],
      modelAddFlag: false,
      modelEditFlag: false,
      modelDetailFlag: false,
      modelImportFlag: false,
      ctmsShow: true,
      listQuery: {
        gmtCreatedRange: "",
        driverLicenseDueDateRange: "",
        driverLicenseDueDateRange1: "",
        driverLicenseDueDateRange2: "",
        driverLicenseDueDateRange3: "",
        driverLicenseDueDateRange4: "",
        authTimeRange: [],
        branchCodeExt: "",
        authStatus: "",
        authStatusExt: "",
        name: "",
        phone: "",
        identificationNumber: "",
        driverLicenseDueDate: "",
        vehicleLicenseDueDate: "",
        roadTransportCertificateDate: "",
        workLicenseDueDate: "",
        balanceStart: "",
        balanceEnd: "",
        gmtCreatedEnd: "",
        gmtCreatedStart: "",
        driverType: 0,
        pageNum: 1,
        pageSize: 20,
        sortField: "",
        sortType: "",
        total: 0
      },
      sumObject: {
        balance: 0
      },
      // 审核状态
      authStatusExtOptions: [
        { label: "未审核", value: 0, color: "gray" },
        // { label: "审核中", value: 1, color: "#0000ff" },
        { label: "审核未通过", value: 2, color: "#ff0000" },
        { label: "审核通过", value: 3, color: "#00bd93" }
      ],
      //车辆入网
      vehicleNetStatusOptions: [
        {
          label: "未入网",
          value: 0
        },
        {
          label: "已入网",
          value: 1
        }
      ],
      // 挂车
      isHasTrailerOptions: [
        { label: "否", value: 0 },
        { label: "是", value: 1 }
      ],
      // 是否admin
      isAdmin: false,
      // 是否顶级机构，只有顶级机构可以对车队增删改
      isTopBranch: false,
      // 实名认证
      formData: {},
      // 认证类型
      verifyType: 0,
      driverManage_RealName_button: false,
      driverManage_detail_button: false,
      driverManage_edit_button: false,
      driverManage_delete_button: false,
      driverManage_ApplyDis_button: false,
      driverManage_recoveryBackMoney_button: false,
      driverManage_cancelRecharge_button: false,
      driverManage_oilOrderBackMoney_button: false
    };
  },
  watch: {
    "$store.state.tagsView.cachedViews": function(cachedViews) {
      if (!cachedViews.includes("DriverManage")) {
        let route = this.getRoute(this.$router.options.routes);
        route.meta.keepLive = false;
      }
    },
    "$route.query.needRefreshDriver": function(newVal, oldVal) {
      // 新增调回需要刷新数据
      if (newVal) {
        this.$nextTick(() => {
          this.RefreshList();
          let newQuery = JSON.parse(JSON.stringify(this.$route.query));
          delete newQuery.needRefreshDriver;
          this.$router.replace({ query: newQuery });
        });
      }
    }
  },
  created() {
    const partyType = this.$store.getters.party.partyType;
    this.isAdmin =
      partyType == "SUPER_ADMIN" ||
      partyType == "PLAT_ADMIN" ||
      partyType == "STAFF";
    this.findList();
    this.isCtmsShow = getRole(); //获取登录用户登录的是否是同城系统
    let dataBranch = JSON.parse(localStorage.getItem("dataBranch"));
    this.platformDid = dataBranch.platformDid;
    if (
      dataBranch.partyGroupConfigCacheMap.MaYiBlockChainConfig_useMaYiBlockChain
    ) {
      this.openMaYiBlockChain =
        dataBranch.partyGroupConfigCacheMap
          .MaYiBlockChainConfig_useMaYiBlockChain.configValue == 1;
    }
    this.listQuery.branchCodeExt = JSON.parse(
      localStorage.getItem("dataBranch")
    ).code;
    this.isTopBranch = dataBranch.level == 0;
    verifyIdentityOnOff({ branchCode: dataBranch.code }).then(response => {
      this.verifyType = response.data.toVerifyIdentity;
    });
    this.driverManage_RealName_button = this.getLimit(
      "driverManage_RealName_button"
    );
    this.driverManage_detail_button = this.getLimit(
      "driverManage_detail_button"
    );
    this.driverManage_edit_button = this.getLimit("driverManage_edit_button");
    this.driverManage_delete_button = this.getLimit(
      "driverManage_delete_button"
    );
    this.driverManage_ApplyDis_button = this.getLimit(
      "driverManage_ApplyDis_button"
    );
    this.driverManage_recoveryBackMoney_button = this.getLimit(
      "driverManage_recoveryBackMoney_button"
    );
    this.driverManage_cancelRecharge_button = this.getLimit(
      "driverManage_cancelRecharge_button"
    );
    this.driverManage_oilOrderBackMoney_button = this.getLimit(
      "driverManage_oilOrderBackMoney_button"
    );
  },
  methods: {
    getRoute(routerList) {
      var list = "";
      for (let item of routerList) {
        if (item.children) {
          let clist = this.getRoute(item.children);
          if (this.getRoute(item.children)) {
            return clist;
          }
        }
        if (item.name == "DriverManage") {
          list = item;
          return list;
        }
      }
      return list;
    },
    // 实名认证
    toRealName(partyCode, peopleImg) {
      const checkedRowArray = this.$refs.xTable.getCheckboxRecords();
      this.$refs.xTable.clearCheckboxRow();
      let code = "";
      if (checkedRowArray.length == 1) {
        code = checkedRowArray[0];
      } else if (partyCode) {
        code = partyCode;
      } else {
        return this.$message.warning("请选择一个要实名认证的实际承运人！");
      }
      this.$refs.realNameRef.show(code, peopleImg);
    },
    showApplyDisBtn(row) {
      if (!this.openMaYiBlockChain || this.isCtmsShow) {
        return false;
      }
      let hasDid = !(
        typeof this.platformDid == "undefined" || this.platformDid == ""
      );
      return (
        this.isTopBranch &&
        hasDid &&
        row.authStatusExt == 3 &&
        (row.szwlDid == null || row.szwlDid == "")
      );
    },
    findList() {
      this.loading = true;
      return new Promise(resolve => {
        request({
          url: "/ntocc-basic-api/driver",
          method: "get",
          params: this.listQuery
        }).then(response => {
          this.tableData = response.data.records;
          this.listQuery.total = response.data.total;
          this.sumObject = response.data.sumObject;
          this.loading = false;
          resolve();
        });
      });
    },
    // 添加
    funcAdd() {
      this.$router.push({
        path: "/basicInfo/driver/addDriverForm"
      });
    },
    // 设置必填项
    funcheckQuire(row) {
      this.$router.push({
        path: "/basicInfo/driver/requiredDriverForm",
        query: { checkQuire: true }
      });
    },
    // 导入
    funcImport() {
      this[`modelImportFlag`] = true;
      this.$refs[`driverImportRef`].init();
    },
    // 编辑
    funcEdit(code, partyCode) {
      this.$router.push({
        path: "/basicInfo/driver/editDriverForm",
        query: { code, partyCode, isDetail: 0 }
      });
    },
    // 详情方法
    funcDetail(code, partyCode) {
      this.$router.push({
        path: "/basicInfo/driver/infoDriverForm",
        query: { code, partyCode, isDetail: 1 }
      });
    },
    // 删除方法
    funcDelete(code) {
      this.$confirm("确认删除吗？")
        .then(_ => {
          const rLoading = this.openLoading("正在删除...");
          request({
            url: `/ntocc-basic-api/driver/batchDel`,
            method: "delete",
            params: { codes: code }
          }).then(response => {
            this.$message({ message: response.msg, type: "success" });
            rLoading.close();
            this.findList();
          });
        })
        .catch(_ => {});
    },
    // 申请DIS
    async funcApply(codes) {
      let response = await maYiBlockChain(codes);
      this.$message({ message: response.msg, type: "success" });
      this.findList();
    },
    // 翻译审核状态
    formatterAuthStatus({ cellValue }) {
      const item = this.authStatusOptions.find(
        item => item.value === cellValue
      );
      return item ? item.label : "";
    },
    // 翻译
    formatterField({ cellValue }, prefix) {
      const item = this[`${prefix}Options`].find(
        item => item.value === cellValue
      );
      return item ? item.label : "";
    },
    // 隐藏弹框
    hideModel() {
      this.modelImportFlag = false;
      this.findList();
    },
    hideModelR() {
      this.findList();
    },
    // 增加组件的父方法
    fatherAdd() {
      this.modelAddFlag = false;
      this.findList();
    },
    // 编辑组件的父方法
    fatherEdit() {
      this.modelEditFlag = false;
      this.findList();
    },
    // 公共取消
    fatherCancel(modelFlag) {
      switch (modelFlag) {
        case "add":
          this.modelAddFlag = false;
          break;
        case "edit":
          this.modelEditFlag = false;
          break;
        case "detail":
          this.modelDetailFlag = false;
          break;
        default:
      }
    },
    //提示标红
    cellClassName({ row, rowIndex, column, columnIndex }) {
      const overDueType = row.overDueType || [];
      //驾驶证
      if (column.property === "driverLicenseDueDate") {
        if (overDueType.indexOf("driver") > -1) {
          return "col-red";
        }
      }
      //形驶证
      if (column.property === "vehicleLicenseDueDate") {
        if (overDueType.indexOf("vehicle") > -1) {
          return "col-red";
        }
      }
      //从业资格证
      if (column.property === "workLicenseDueDate") {
        if (overDueType.indexOf("work") > -1) {
          return "col-red";
        }
      }
      //从业资格证
      if (column.property === "roadTransportCertificateDate") {
        if (overDueType.indexOf("road") > -1) {
          return "col-red";
        }
      }
      //身份证
      if (column.property === "idCardDueDate") {
        if (overDueType.indexOf("idCard") > -1) {
          return "col-red";
        }
      }
    },
    // 合计
    // footerMethod({ columns, data }) {
    //   return [
    //     columns.map((column, columnIndex) => {
    //       if (columnIndex === 0) {
    //         return "合计";
    //       }
    //       if (column.property === "balance") {
    //         return this.sumObject.balance;
    //       }
    //       return "-";
    //     })
    //   ];
    // },
    // 万金油余额回收
    funcRecoveryBackMoney(row) {
      this.$refs.oilRecoveryBackMoneyRef.show(row);
    },
    // 万金油待领取撤销
    funcCancelRecharge(row) {
      this.$refs.oilCancelRechargeRef.show(row);
    },
    // 万金油余额
    funOilOrderBackMoney(row) {
      this.$refs.oilOrderBackMoneyRef.show(row);
    },
    // 创建虚拟账号方法
    funcDobiz(codes) {
      this.$confirm("确认需要创建光大虚拟账号吗？")
        .then(_ => {
          syncMemName({ code: codes }).then(response => {
            this.$message({ message: response.msg, type: "success" });
            this.findList();
          });
        })
        .catch(_ => {});
    }
  }
};
</script>
<style scoped>
.mytable-style .vxe-body--column.col-red {
  background-color: red;
  color: #fff;
}
</style>
